import { TransformControls } from '@react-three/drei';
import { useState } from 'react';
import * as THREE from 'three';
import { assetChanged } from '../editor/components/lib/asset-changed';

export enum EDITOR_MODE {
  SCALE = 'scale',
  ROTATE = 'rotate',
  TRANSLATE = 'translate',
}

const getKeyObject = (editorModeValue: EDITOR_MODE) => {
  switch (editorModeValue) {
    case EDITOR_MODE.SCALE:
      return 'scale';
    case EDITOR_MODE.ROTATE:
      return 'rotation';
    case EDITOR_MODE.TRANSLATE:
    default:
      return 'position';
  }
};

export function SceneEditor({
  selectedModel,
  editorMode = EDITOR_MODE.TRANSLATE,
  setSelectedModelProps,
  selectedModelProps,
  dispatchChangeAsset,
}) {
  const [oldState, setOldState] = useState<any>();

  if (
    typeof window !== 'undefined' &&
    (window as any).isTransformControlsDragging === undefined
  ) {
    (window as any).isTransformControlsDragging = false;
  }

  return (
    <TransformControls
      object={selectedModel.props.asset.ref.current}
      mode={editorMode}
      showX={true}
      showY={true}
      showZ={true}
      size={1}
      camera={undefined}
      makeDefault={false}
      onMouseDown={(event: any) => {
        (window as any).isTransformControlsDragging = true;

        const keyObject = getKeyObject(editorMode);
        const value = event?.target.object[keyObject];

        setOldState(() => ({ ...value }));
      }}
      onMouseUp={(event: any) => {
        (window as any).isTransformControlsDragging = false;
        (window as any).justFinishedDragging = true;

        const keyObject = getKeyObject(editorMode);
        const value = event?.target.object[keyObject];

        const newProps = {
          ...selectedModelProps,
        };

        const prevProps = {
          ...selectedModelProps,
        };

        newProps[keyObject] = new THREE.Vector3(value.x, value.y, value.z);
        prevProps[keyObject] = new THREE.Vector3(
          oldState?.x,
          oldState?.y,
          oldState?.z
        );

        if (assetChanged(prevProps, newProps, true)) {
          dispatchChangeAsset({
            type: 'change',
            newData: newProps,
            prevProps,
            elementId: selectedModel.props.asset.ref.current.uuid,
          });

          window.dispatchEvent(
            new CustomEvent('scene_asset_changed', {
              detail: { hasChanges: true },
            })
          );
        }

        setSelectedModelProps(newProps);
      }}
    />
  );
}
